import { DataService } from "../Services/dataService";
import { FirebaseService } from "../Services/firebaseService";

export class Menu {

    logoutElement: HTMLElement = document.getElementById('deconnexion') as HTMLElement
    videoElement: HTMLElement = document.getElementById('formationBtn') as HTMLElement;
    appElement: HTMLElement = document.getElementById('appBtn') as HTMLElement;

    firebaseService: FirebaseService;
    dataService: DataService;
    constructor() {
        this.firebaseService = new FirebaseService();
        this.dataService = new DataService();
        this.init();
    }

    async init() {
        this.logoutElement.addEventListener('click', async () => {
            await this.firebaseService.logout();
            this.goToHome();
            console.log("logout")
        })

        let token = await this.firebaseService.getUserIdToken();
        if (!token) {
            console.log("notlogged")
            this.goToHome();
        }

        //check subscription
        this.appElement.style.display = "none";
            this.videoElement.style.display = "none";
        let user = await this.dataService.getUser(await this.firebaseService.getUserEmail(), await this.firebaseService.getUserIdToken());
        if (user.subscriptionStatus == "subscribed") {
            this.appElement.style.display = "block";
            this.videoElement.style.display = "block";
        }
        else {
            this.appElement.style.display = "none";
            this.videoElement.style.display = "none";
        }
    }

    goToHome() {
        window.location.href = "/connexion";
    }


}
